module.exports = __webpack_public_path__ + "static/media/PizzaMan.22551d46.png";